import React from 'react';

import { Avatar, Text } from '@change/ds-core-ui/next';

import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { useTracking } from '../../../hooks/useTracking';
import type { NormalizedDecisionMaker } from '../../../shared/types';
import { DecisionMakerResponse } from '../../shared/DecisionMakerResponse';
import { Name } from '../../shared/Name';
import { SignersText } from '../../shared/SignersText';

export const Member: React.FC<NormalizedDecisionMaker> = ({
	photoUrl,
	displayName,
	publiclyVisible,
	slug,
	id,
	title,
	signersText,
	response,
}) => {
	const { trackDMMoreInfoClick } = useTracking();
	return (
		<div className="flex" data-qa="dm-card">
			<Avatar src={photoUrl || undefined} alt={displayName} size={32} className="mb-3 mr-3 flex-shrink-0" />
			<div className="flex flex-col md:items-start">
				<div className="mb-2">
					<div className="flex items-center gap-[6px]">
						<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
						{signersText && (
							<div className="lg:hidden">
								<div className="flex items-center">
									<InfoTooltip
										aria-label="Information about signers"
										data-qa="dm-info-tooltip"
										onClick={() => trackDMMoreInfoClick(signersText)}
									>
										{signersText}
									</InfoTooltip>
								</div>
							</div>
						)}
					</div>

					<div className="flex flex-wrap items-center gap-x-3 gap-y-2">
						<Text variant="body" className="text-muted text-sm">
							{title}
						</Text>

						{signersText && (
							<div className="hidden lg:inline-block">
								<SignersText signersText={signersText} />
							</div>
						)}
					</div>
				</div>

				{response && <DecisionMakerResponse response={response} />}
			</div>
		</div>
	);
};
